import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import { EditDebitCardTransactionImagesState } from '../../EditDebitCardTransactionImages.types'

type EditDebitCardTransactionImagesLocationState = {
  EditDebitCardTransactionImagesModal?: EditDebitCardTransactionImagesState
}

export const useEditDebitCardTransactionImagesState = () => {
  const location = useLocation<
    EditDebitCardTransactionImagesLocationState | undefined
  >()

  const state = useMemo(() => {
    if (
      !location.state?.EditDebitCardTransactionImagesModal?.stage ||
      location.state.EditDebitCardTransactionImagesModal.stage !== 'edit'
    ) {
      return null
    }

    return location.state.EditDebitCardTransactionImagesModal
  }, [location])

  return { state }
}
